import { useState, useEffect } from "react";

import CustomLabel from "@/components/inputs/CustomLabel";
import CustomSelect from "@/components/inputs/CustomSelect";

const FilterDefinition = ({
  value,
  label,
  multi = false,
  placeholder = "Начните вводить",
  options,
  onSubmit,
}) => {
  const [val, setVal] = useState(value?.uuid);

  useEffect(() => {
    setVal(value?.uuid || value);
  }, [value]);

  return (
    <div>
      {label && <CustomLabel text={label} />}
      <CustomSelect
        value={val}
        placeholder={placeholder}
        options={options}
        onChange={(val) => {
          setVal(val || null);
          onSubmit(val || null);
        }}
        style={{ width: "100%" }}
        showSearch
        allowClear
        mode={multi ? "multiple" : undefined}
        fieldNames={{ value: "uuid" }}
        optionFilterProp="label"
      />
    </div>
  );
};

export default FilterDefinition;
